import * as React from "react";
import StudentDonutChart from "./student-donut-chart";
import WidgetHeader from "../common/widget-header";
var SfoHeader = function (props) { return (React.createElement("div", { className: "column-top-section" },
    React.createElement(WidgetHeader, { title: props.title }),
    React.createElement(StudentDonutChart, { stats: props.stats, setGroup: props.setGroup, selectedGroup: props.selectedGroup }))); };
export default SfoHeader;
